const ITEMS = [
  "U.S. PATENT 10,410,553 B2",
  "100% AMERICAN MADE",
  "PROVEN IN 40+ MPH WINDS",
  "NO COLLAPSE GUARANTEE",
  "15-MINUTE INSTALL",
  "WHOLESALE PROGRAMS",
  "FRANCHISE ROLLOUTS",
];

export default function Marquee({ className = "" }) {
  return (
    <div className={`relative border-y border-girder bg-steel/60 px-4 py-4 ${className}`} data-testid="trust-bar">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-7 gap-y-2.5">
        {ITEMS.map((item, i) => (
          <span key={item} className="flex items-center gap-7">
            {i > 0 && <span className="h-1.5 w-1.5 rotate-45 bg-hivis/70" aria-hidden="true" />}
            <span className="whitespace-nowrap font-display text-sm font-bold uppercase tracking-[0.18em] text-slate-400 md:text-base">{item}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
